import { Gift } from 'lucide-react'

import { useCart } from '@/contexts/CartContext'
import { useAddToCart, useProducts } from '@/hooks/features/catalog'

/** "Free with offer" prompts: the customer earned the item; one tap adds it and the offer prices it (A8). */
export const RewardPrompts = () => {
  const { rewards } = useCart()
  const { add } = useAddToCart()
  const { data } = useProducts({})
  if (!rewards.length) return null

  return (
    <ul className="space-y-1.5 border-t border-border-subtle px-4 py-3" aria-label="Offer rewards">
      {rewards.map((r) => {
        const product = data?.items.find((p) => p._id === r.variationId)
        if (!product) return null
        return (
          <li key={`${r.offerId}-${r.variationId}`} className="flex items-center gap-2 rounded-md bg-success-lighter/60 px-3 py-2 text-sm">
            <Gift className="size-4 shrink-0 text-success-dark" />
            <span className="min-w-0 flex-1 truncate text-success-darker">
              {r.offerName ? `${r.offerName}: ` : 'Offer: '}
              {r.missing} × {product.name}
            </span>
            <button
              type="button"
              onClick={() => add(product, r.missing)}
              className="shrink-0 rounded-sm px-2 py-1 text-xs font-semibold text-success-dark hover:bg-success-lighter disabled:opacity-40"
            >
              Add
            </button>
          </li>
        )
      })}
    </ul>
  )
}
